import { Button } from '@/components/ui/button.tsx'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog.tsx'
import { Separator } from '@/components/ui/separator.tsx'

import { useRemoveStory } from '@/requests/mutations/useRemoveStory.ts'
import { isTemporaryId } from '@/utils/key.ts'

type Props = {
  story: Story
}

export const StoryDeleteButton = ({ story }: Props) => {
  const remove = useRemoveStory(story.id)

  return (
    <>
      <Dialog>
        <DialogTrigger tabIndex={0} asChild disabled={isTemporaryId(story.id) || story.acceptedAt !== null}>
          <Button type="button" variant="icon" size="icon" className="h-5 w-5 rounded-xs p-0">
            <img src="/images/story-delete-icon.svg" alt="delete this story" />
          </Button>
        </DialogTrigger>

        <DialogContent className="[&>button:last-child]:hidden rounded-lg bg-surface-backgroundElevated shadow-dropshadow-400 py-4 px-0">
          <DialogHeader>
            <DialogTitle className="font-EN-KR-sub-heading-bold text-contents-primary px-4">Delete Story</DialogTitle>
            <Separator className="my-4" />
            <DialogDescription className="sr-only" />
            <div className="px-4 pb-4 flex flex-col items-center justify-center text-contents-primary font-EN-KR-body1-regular">
              <p>
                Are you sure you <span className="text-contents-alert">want to delete</span> this story?
              </p>
              <p className="font-bold">{`"${story.title}"`}</p>
            </div>
          </DialogHeader>
          <DialogFooter className="px-4">
            <div className="flex w-full justify-between items-center">
              <DialogClose asChild>
                <Button type="button" variant="outline" className="font-EN-KR-body1-regular">
                  Cancel
                </Button>
              </DialogClose>
              <DialogClose asChild>
                <Button type="button" variant="alert" onClick={() => remove()} className="font-EN-KR-body1-bold">
                  Delete
                </Button>
              </DialogClose>
            </div>
            <DialogClose asChild>
              <Button type="button" size="icon" variant="ghost" className="absolute top-[18px] right-[16px]">
                <img src="/images/close-dialog-icon.svg" alt="close" />
              </Button>
            </DialogClose>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
